import React from "react";
import Button from "@mui/material/Button";
import Tooltip from "@material-ui/core/Tooltip";

function IconButton(props) {
  return (
    <div>
      <Tooltip disableFocusListener title={props.tooltip} arrow>
        <Button
          {...props}
          size={"small"}
          variant={"contained"}
          className={props.className}
          onClick={props.onClick}
          startIcon={props.icon ? props.icon : null}
        >
          {props.text}
        </Button>
      </Tooltip>
    </div>
  );
}

export default IconButton;
